var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "tutorialsModal",
        size: "md",
        "content-class": "menu-bg-blue-transparent-modal tut-modal",
        title: _vm.tutorial ? "Update Tutorial" : "Add New Tutorial",
        "hide-footer": "",
      },
      on: {
        hide: function ($event) {
          return _vm.reset()
        },
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "px-4 pt-0", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-row", [_c("label", [_vm._v("Name")])]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-form-input", {
                    class: _vm.missingFields.name ? "red" : "",
                    attrs: {
                      placeholder: "Name...",
                      disabled: _vm.tutorial ? true : false,
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "p-4", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-row", [_c("label", [_vm._v("Description")])]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-textarea", {
                    class: _vm.missingFields.description ? "red" : "",
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "w-100", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { staticClass: "mx-auto", attrs: { cols: "auto" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-auto",
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.tutorial ? _vm.submitUpdate() : _vm.submitNew()
                    },
                  },
                },
                [_vm._v("SUBMIT")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }